import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
/** components **/
import { SurveySimpleLayout } from 'components/organisms';
/** lib **/
import { floorPlans } from 'lib/floor-plans';
/** styles **/
import s from '../styles/pages/survey-floor-plan.module.scss';
/** images **/
import PwanSmall from 'assets/images/p-wan-small.png';
import FantasyApartment from 'assets/images/FantasyApartment.png';
import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';

const DisabledArrowIcon = () => (
  <svg width="7" height="9" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 8.43347L6 4.93347L1 1.43347" stroke="#D8D7BB" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SurveyFloorPlan: React.FC = () => {
  const [selectedPlan, setSelectedPlan] = useState<string>('');
  const navigate = useNavigate();

  const handlePlanSelect = (planId: string) => {
    setSelectedPlan(planId);
  };

  const handleProceed = () => {
    if (selectedPlan) {
      // Navigate to rent plan page
      navigate('/survey/rent01', { state: { selectedFloorPlan: selectedPlan } });
    }
  };

  return (
    <SurveySimpleLayout>
      <div className={s.surveyFloorPlanWrapper}>
        {/* ページタイトル */}
        <section className={s.titleSection}>
          <h1 className={s.pageTitle}>「P-man」<br />妄想マンション投票第2弾</h1>
          <p className={s.voiceText}>あなたの声を聞かせてください</p>
          <p className={s.subTitle}>
            「P-man」に住むとしたら<br />
            どの間取りがいいですか？
          </p>
        </section>

        {/* 選択肢セクション */}
        <section className={s.selectionSection}>
          <div className={s.optionsContainer}>
            {floorPlans.map((plan, index) => (
              <div
                key={plan.id}
                className={s.optionWrapper}
                style={{ zIndex: index + 1 }}
              >
                {selectedPlan === plan.id && (
                  <img src={PwanSmall} alt="ピーワン" className={s.selectedCharacter} />
                )}
                <button
                  className={`${s.optionButton} ${selectedPlan === plan.id ? s.selected : ''}`}
                  onClick={() => handlePlanSelect(plan.id)}
                >
                  <span className={s.planText}>
                    <span className={s.planNumber}>{plan.displayText.split('㎡')[0]}</span>
                    <span className={s.planUnit}>㎡</span>
                    <span className={s.planType}>{plan.displayText.split('㎡')[1]}</span>
                  </span>
                </button>
              </div>
            ))}
          </div>

          <p className={s.supplementText}>
            次のページから<br />
            選択いただいた間取り別のお家賃プランについて<br />
            質問させていただきます。
          </p>

          <div className={s.apartmentImageWrapper}>
            <img src={FantasyApartment} alt="ファンタジーアパートメント" className={s.apartmentImage} />
          </div>

          <div className={s.navigationButtons}>
            <Link to="/survey" className={s.backButton}>
              戻る
            </Link>
            <button
              className={s.proceedButton}
              onClick={handleProceed}
              disabled={!selectedPlan}
            >
              <span className={s.proceedButtonText}>進む</span>
              {selectedPlan ? (
                <GreenCircleArrow className={s.proceedButtonIcon} />
              ) : (
                <DisabledArrowIcon />
              )}
            </button>
          </div>
        </section>
      </div>
    </SurveySimpleLayout>
  );
};